<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">請求管理</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <md-card-content v-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <loading-spinner v-else-if="loadingSpinner"></loading-spinner>
      <div v-else class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求月</md-table-cell>
                <md-table-cell v-if="billing.billing_month !== null">
                  {{datetimeFormat(billing.billing_month + '01', 'YYYY年M月')}}（{{datetimeFormat(billing.use_month,
                  'M月')}}ご利用分）
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">伝票番号</md-table-cell>
                <md-table-cell>{{billing.no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">法人名</md-table-cell>
                <md-table-cell>{{billing.corporation}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">支払方法</md-table-cell>
                <md-table-cell>{{getBillingMethod(billing)}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求額(税込)</md-table-cell>
                <md-table-cell v-if="billing.total_billed !== null">
                  {{numberFormat(billing.total_billed)}}円
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">入金額</md-table-cell>
                <md-table-cell v-if="billing.total_paid !== null">
                  {{numberFormat(billing.total_paid)}}円
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">支払状況</md-table-cell>
                <md-table-cell>{{paymentStatusLabelAdmin(billing.status)}}</md-table-cell>
              </md-table-row>
              <md-table-row v-if="getGmoPaymentIdLabel(billing.payment_method)">
                <md-table-cell class="md-layout md-alignment-center-right">
                  {{getGmoPaymentIdLabel(billing.payment_method)}}
                </md-table-cell>
                <md-table-cell>{{getGmoPaymentId(billing.payment_method)}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求書送付</md-table-cell>
                <md-table-cell>{{getPaymentInfo(billing)}}
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求書/明細</md-table-cell>
                <md-table-cell>
                  <md-button :href="billing.pre_signed_url" target="_blank" class="md-raised"
                             v-if="billing.pre_signed_url">
                    <md-icon class="material-icons">
                      picture_as_pdf
                    </md-icon>
                    <span>ダウンロード</span>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </div>
      </div>
    </md-card>
  </main>
</template>

<script>

  import FlashMessage                                      from '../../../components/FlashMessage';
  import LoadingSpinner                                    from '../../../components/LoadingSpinner';
  import Common                                            from '../../../modules/common';
  import CommonMixin                                       from '../../../mixins/commonMixin';
  import {apiClientWithManagerToken as apiClient, apiList} from '../../../modules/apiClient';
  import axios                                             from 'axios';
  import {mapActions}                                      from 'vuex';

  export default {
    name      : "AdminBillingDetail",
    props     : {
      id           : String,
      corporationId: String,
    },
    mixins    : [CommonMixin],
    components: {
      FlashMessage,
      LoadingSpinner
    },
    data      : () => ({
      checkBoxBillingMethods: Common.billingMethods,
      checkBoxBillingVia    : Common.billingVia,
      errorMessages         : [],
      billing               : [],
    }),
    mounted   : function () {
      this.initDisplay();
    },
    methods   : {
      ...mapActions('adminBillings', [
        'saveBack',
      ]),
      backToList() {
        this.saveBack(true);
        this.$router.replace({name: 'BackendAdminBillings'}).then();
      },
      initDisplay() {
        this.loadingSpinner = true;
        const url           = apiList.jon.billings.detail.replace(':corporation_id', this.$props.corporationId).replace(':id', this.$props.id);
        axios
          .all([
            apiClient.get(apiList.jon.corporations.corporations),
            apiClient.get(url),
          ])
          .then(axios.spread((...responses) => {
            const corporationsResponse = responses[0];
            const detailResponse       = responses[1];
            if (this.hasResponseErrors(corporationsResponse)
              || this.hasResponseErrors(detailResponse)) {
              return;
            }

            if (detailResponse.data.billing) {
              this.billing                = detailResponse.data.billing;
              this.billing['label']       = this.billing.payment_method ? this.billing.payment_method.label : null;
              this.billing['bill_via']    = this.billing.payment_method ? this.billing.payment_method.bill_via : null;
              this.billing['corporation'] = this.getCorporationName(corporationsResponse.data.corporations, this.billing.corporation_id);
              return;
            }
            this.errorMessages = [Common.messages.errorGet];
          }))
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loadingSpinner = false;
          });
      },
      getCorporationName(corporations, corporationId) {
        const corporation = corporations.filter(function (corporation) {
          return corporationId === corporation.corporation_id;
        });
        if (corporation && corporation.length > 0) {
          return corporation[0].name;
        }
        return null;
      },
      getPaymentInfo(billing) {
        if (!billing.payment_method) {
          return null;
        }
        const billVia = this.getBillViaName(billing.payment_method.bill_via);
        const email   = billing.payment_method.email ? `（${billing.payment_method.email}）` : null;
        return `${billVia}${email}`;
      },
      getBillingMethod(billing) {
        if (!billing.payment_method) {
          return '';
        }
        return this.getBillMethodName(billing.payment_method.bill_method);
      },
    }
  }
</script>

<style lang="scss" scoped>
  tbody .md-table-row .md-table-cell,
  tbody .md-table-row .md-table-cell:last-child,
  tbody .md-table-row:last-child .md-table-cell {
    border: none;
  }
</style>
